var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding_top component-container"},[(_vm.img_url)?_c('div',{staticClass:"image-wrap has_img",on:{"click":_vm.gotoDetail}},[_c('img',{attrs:{"src":_vm.img_url}})]):_c('div',{staticClass:"image-wrap"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-previewer"},[_c('img',{attrs:{"src":require("@/assets/images/mofang/image-preview.png")}})])
}]

export { render, staticRenderFns }